$(document).ready(function() {
    /*******************************************/

    //Form Validation
    $('.search-magnifying').on('click', function() {
        $('.search-line').toggle();
    });

    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.parents('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else if(element.type === 'checkbox') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else if(element.type === 'checkbox') {
                    this.findByName(element.name).closest('.form-field').removeClass('error');
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });


    /*******************************************/
    //Custom Select Dropdown 
    $(function() {
        $('.custom-select-dropdown').selectric();
    });

    /*******************************************/
    //Lightbox Initiations
    $('.open-popup-link').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*******************************************/
    // Tabs
    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });

    /*******************************************/
    // Toggle Triggers
    $('.js-nav-trigger').on('click', function() {
        $('html').toggleClass('nav-open');
    });

    $('.js-toggle-trigger').on('click', function() {
        $(this).closest('.js-toggle').toggleClass('toggle-open');
    });

    $('.js-list').on('click', 'span', function() {
        $(this).closest('li').toggleClass('list-open');
    });

});


/*******************************************/
$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    //d.setTime(d.getTime() + 1);

    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    var user = getCookie("username");
    if (user != "") {
        alert("Welcome again " + user);
    } else {
        user = prompt("Please enter your name:", "");
        if (user != "" && user != null) {
            setCookie("username", user, 365);
        }
    }
}
/*******************************************/
//Main Menu
// function slideMenu(action){ 
//     var $menu = $('#mobile-menu') 
//     if (!action) { toggle(); return }
//     if (action == "open") { open(); return }
//     if (action == "close") { close(); return }

//     function open(){
//         $("body").addClass('open-menu');
//         $menu.attr('status', 'open');
//     }
//     function close(){
//         $("body").removeClass('open-menu');
//         $menu.attr('status', 'closed');
//     }
//     function toggle(){
//         var status =  $menu.attr('status');
//         if (status == "open"){ close(); return }
//         if (status == "closed"){ open(); return }
//     }
// }

// $('#mobile-menu li').each(function(){
//         $(this).has("ul").addClass('mobile-menu-parent');
// });

// $( ".mobile-menu-parent .icon" ).on("click", function(){
//     $(this).siblings('ul').slideToggle(150);
// });

// //prevent slide up
// $(".mobile-menu-parent").on("click", "ul", function(event){
//     event.stopPropagation()
// })

/*******************************************/
// Header Highlighter
$(document).ready(function() {
    var headerHref = "#site-header";
    var mobileHref = "#mobile-menu";
    var myURL = "/" + location.pathname.split('/')[1];
    $('#about').removeClass('selected');
    $(headerHref + ' li').each(function(){
      
        if ($(this).find('a').attr('href') == myURL) {
          if(myURL == '/about-us'){
           
            $(this).find('a').removeClass("selected")
          }
          if($(this).find('a').attr('class') == 'subHeader'){
            //alert('ccc');
            $('#about').removeClass('selected');
            $(this).find('a').addClass("sub")
            $(this).find('a').removeClass("selected")
            return
          }else{
            $(this).find('a').addClass("selected")
            $('#about').removeClass('selected');
            return
          }
            
        }
    })

    $(mobileHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })
});

/*******************************************/



